"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileAttributesTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const lists_1 = require("src/lists");
const app_1 = require("app");
const AttributesTable_1 = require("./AttributesTable");
const ShowMoreLessButton_1 = require("./ShowMoreLessButton");
const TileAttributesTable = ({ attributes, showMoreLabel, showLessLabel, }) => {
    const DEFAULT_ATTRIBUTES_COUNT = 2;
    const [isAllAttributesShown, setIsAllAttributesShown] = React.useState(false);
    const [isScreenDesktop, setIsScreenDesktop] = React.useState((0, app_1.isDesktop)());
    const allAttributesKeys = React.useMemo(() => (0, lists_1.sortAlphabetically)((0, app_1.safe)(Object.keys(attributes))), [attributes]);
    const { firstTableKeys, secondTableKeys } = React.useMemo(() => {
        const allAttributesKeysCount = allAttributesKeys.length;
        const arraysDivider = Math.ceil(allAttributesKeysCount / 2);
        return {
            firstTableKeys: allAttributesKeys.slice(0, arraysDivider),
            secondTableKeys: allAttributesKeys.slice(arraysDivider, allAttributesKeysCount),
        };
    }, [allAttributesKeys]);
    const isShowMoreButtonNeeded = React.useMemo(() => {
        const tablesCount = isScreenDesktop ? 2 : 1;
        return allAttributesKeys.length > DEFAULT_ATTRIBUTES_COUNT * tablesCount;
    }, [allAttributesKeys.length, isScreenDesktop, DEFAULT_ATTRIBUTES_COUNT]);
    const checkIfDesktop = React.useCallback(() => {
        const isDesktopNow = (0, app_1.isDesktop)();
        if (isDesktopNow !== isScreenDesktop) {
            setIsScreenDesktop(isDesktopNow);
        }
    }, [isScreenDesktop]);
    const onWindowResize = React.useMemo(() => (0, app_1.debounce)(checkIfDesktop, 100), [checkIfDesktop]);
    React.useEffect(() => {
        window.addEventListener('resize', onWindowResize);
        return () => {
            window.removeEventListener('resize', onWindowResize);
        };
    }, [onWindowResize]);
    const onClick = (e) => {
        e.preventDefault();
    };
    const onClickShowMoreLessButton = () => {
        setIsAllAttributesShown(prev => !prev);
    };
    if (allAttributesKeys.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "w-full cursor-default", onClick: onClick, children: [(0, jsx_runtime_1.jsx)("div", { className: "flex flwex-col gap-sm", children: isScreenDesktop ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AttributesTable_1.AttributesTable, { attributesKeys: firstTableKeys, attributesObject: attributes, defaultRowsCount: DEFAULT_ATTRIBUTES_COUNT, showAllAttributes: isAllAttributesShown }), (0, jsx_runtime_1.jsx)(AttributesTable_1.AttributesTable, { attributesKeys: secondTableKeys, attributesObject: attributes, defaultRowsCount: DEFAULT_ATTRIBUTES_COUNT, showAllAttributes: isAllAttributesShown })] })) : ((0, jsx_runtime_1.jsx)(AttributesTable_1.AttributesTable, { attributesKeys: allAttributesKeys, attributesObject: attributes, defaultRowsCount: DEFAULT_ATTRIBUTES_COUNT, showAllAttributes: isAllAttributesShown })) }), isShowMoreButtonNeeded ? ((0, jsx_runtime_1.jsx)(ShowMoreLessButton_1.ShowMoreLessButton, { isAllAttributesShown: isAllAttributesShown, onClickShowMoreLessButton: onClickShowMoreLessButton, showMoreLabel: showMoreLabel, showLessLabel: showLessLabel })) : null] }));
};
exports.TileAttributesTable = TileAttributesTable;
